module.exports = __webpack_public_path__ + "static/Race1-24870ef9137b564902175ea0ebf6645d.pdf";